import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { BirthCity, BirthCountry } from "./national-data.model";

export const ACTION_PREFIX = "[National Data]";
export const NATIONAL_DATA_ACTION_TYPE = {
	getBirthCities: `${ACTION_PREFIX} Get Birth Cities`,
	getBirthCitiesSuccess: `${ACTION_PREFIX} Get Birth Cities Success`,
	getBirthCitiesFail: `${ACTION_PREFIX} Get Birth Cities Fail`,
	getCountryByTaxCode: `${ACTION_PREFIX} Get Country By Tax Code`,
	getCountryByTaxCodeSuccess: `${ACTION_PREFIX} Get Country By Tax Code Success`,
	getCountryByTaxCodeFail: `${ACTION_PREFIX} Get Country By Tax Code Fail`,
	getTaxCodeByCountry: `${ACTION_PREFIX} Get Tax Code By Country`,
	getTaxCodeByCountrySuccess: `${ACTION_PREFIX} Get Tax Code By Country Success`,
	getTaxCodeByCountryFail: `${ACTION_PREFIX} Get Tax Code By Country Fail`,
};

/**
 * @deprecated [fabric-deprecated] - use NationalDataService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class NationalDataAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryCitiesNationalData) instead
	 */
	getBirthCities(): Action {
		return createCachedGetAction(
			{
				type: NATIONAL_DATA_ACTION_TYPE.getBirthCities,
			},
			{ cacheKey: `${NATIONAL_DATA_ACTION_TYPE.getBirthCities}` }
		);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryCitiesNationalData) instead
	 */
	getBirthCitiesSuccess(content: BirthCity[]): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getBirthCitiesSuccess,
			payload: content,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryCitiesNationalData) instead
	 */
	getBirthCitiesFail(error: AppError): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getBirthCitiesFail,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryByTaxCodeNationalData) instead
	 */
	getCountryByTaxCode(payload: string): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCode,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryByTaxCodeNationalData) instead
	 */
	getCountryByTaxCodeSuccess(payload: BirthCountry): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCodeSuccess,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryByTaxCodeNationalData) instead
	 */
	getCountryByTaxCodeFail(error: AppError): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCodeFail,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetTaxCodeByCountryNationalData) instead
	 */
	getTaxCodeByCountry(payload: string): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountry,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetTaxCodeByCountryNationalData) instead
	 */
	getTaxCodeByCountrySuccess(payload: BirthCountry): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountrySuccess,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetTaxCodeByCountryNationalData) instead
	 */
	getTaxCodeByCountryFail(error: AppError): ActionWithPayload {
		return {
			type: NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountryFail,
			payload: error,
		};
	}
}
